import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import NotFoundPage from './components/layouts/404';
import Header from "./components/layouts/Header";
import AuthorizationComponent from './components/authorization'
import React from 'react';
import Context from './components/context'
import Feedback from './components/feedback/Feedback';
import Main from './components/main/Main';
import Test from './components/test/Test'
import TaskCreator from './components/creators/taskCreator/taskCreator';
import ComplexTaskCreator from './components/creators/complex-task-ceator/ComplexTaskCreator';
import Profile from './components/profile/Profile';
import FilterEditor from './components/profile/moderator/filterEditor';
import Tests from './components/test/Tests';
import TestEditor from './components/creators/test-creator/test-editor'
import Statistics from './components/statistics/Statistics';
import TestCreator from './components/creators/test-creator/TestCreator';
import QuestionCreator from './components/creators/questionCreator'
import {
  AUTHORIZATION_URL, COMPLEX_CREATOR_URL,
  FEEDBACK_URL, FILTER_EDITOR_URL, INFORMATION_URL, MODERATOR_URL,
  PROFILE_URL,
  STATISTICS_URL,
  TASK_CREATOR_URL, TEST_CREATOR_CREATOR_URL, TEST_CREATOR_URL,
  TEST_URL,
  TESTS_URL, TEXT_CREATOR_URL
} from "./config";
import {Toaster} from 'react-hot-toast';
import API from "./components/API";
import TextCreator from './components/creators/textCreator/TextCreator';
import Moderator from "./components/profile/moderator/Moderator";
import Information from "./components/layouts/Information";

function App() {
  let api = new API();
  const [isLoading,setIsLoading] = React.useState(false)
  const [mainState, setMainState] = React.useState(()=>{
    let lang = localStorage.getItem('lang')|| 'ru';
    localStorage.setItem('lang',lang)
    return{
    lang: lang,
    isLoggedIn: Boolean(+localStorage.getItem('isLoggedIn')) || false,
    type: localStorage.getItem('type') || '',
    isTestStart:false
    }
  })
  function changeLanguage(l) {
    setMainState(state => {
      return {
        ...state,
        lang: l,
      } 
    })
    localStorage.setItem('lang', l)
  }
  function setStartTest(isStart) {
    setMainState(state => {
      return {
        ...state,
        isTestStart: isStart,
      }
    })
    localStorage.setItem('isTestStart', isStart)
  }
  function logOut() {
      api.logOut()
      sessionStorage.clear()
      let lang = localStorage.getItem('lang')
      localStorage.clear()
      setMainState(state => {
        return {
          ...state,
          isLoggedIn: false,
          type: '',
        }
      })
      localStorage.setItem('lang', lang)
      localStorage.setItem('isLoggedIn', 0)
      localStorage.setItem('type', '')
  }

  function logIn(type) {
    setMainState(state => {
      return {
        ...state,
        isLoggedIn: true,
        type: type,
      }
    })

    localStorage.setItem('isLoggedIn', 1)
    localStorage.setItem('type', type)
  }

  return (
    <Router>
      <div className='wrapper'>
        <Context.Provider value={{mainState, changeLanguage, logIn, logOut,isLoading,setIsLoading}}>
          {!mainState.isTestStart&&<Header/>}
          <Routes>
            <Route path="/" element={<Main/>}/>
            <Route path={INFORMATION_URL} element={<Information/>}/>
            <Route path={STATISTICS_URL} element={<Statistics/>}/>
            {/* Create component Statistics */}
            <Route path={FEEDBACK_URL} element={<Feedback/>}/>
            <Route path={TEST_URL+'/:id'} element={<Test setIsStart={setStartTest} isTestStart={mainState.isTestStart}/>}/>
            {/* <Route path={TEST_URL+'/:id'} element={<Test/>}/> */}

            <Route path={TESTS_URL} element={<Tests/>}/>
            <Route path={AUTHORIZATION_URL} element={<AuthorizationComponent/>}/>
            <Route path={PROFILE_URL} element={<Profile mainState={mainState}/>}/>
            {/*<Route path={TASK_CREATOR_URL} element={<TaskCreator/>}/>*/}

            <Route path={TASK_CREATOR_URL} element={<QuestionCreator/>}/>
            <Route path={TASK_CREATOR_URL+':id'} element={<QuestionCreator/>}/>

            <Route path={TEST_CREATOR_URL} element={<TestEditor/>}/>
            <Route path={TEST_CREATOR_CREATOR_URL} element={<TestCreator/>}/>
            <Route path={TEST_CREATOR_CREATOR_URL+':id'} element={<TestCreator/>}/>
            <Route path={FILTER_EDITOR_URL} element={<FilterEditor/>}/>
            <Route path={TEXT_CREATOR_URL} element={<TextCreator/>}/>
            <Route path={TEXT_CREATOR_URL+':id'} element={<TextCreator/>}/>
            <Route path={COMPLEX_CREATOR_URL} element={<ComplexTaskCreator/>}/>
            <Route path={COMPLEX_CREATOR_URL+':id'} element={<ComplexTaskCreator/>}/>
            <Route path={MODERATOR_URL} element={<Moderator/>}/>


            <Route path="*" element={<NotFoundPage/>}/>
          </Routes>
        </Context.Provider>
      </div>
      <Toaster/>
    </Router>
  );
}
export default App;
